import angular from 'angular'

import displayCtrl from './display.controller'
import displayRoutes from './display.routes'
import displayRun from './display.run'
import displayMenu from './display.menu'

const name = 'routingSettingDisplay'

angular.module(name, [])
  .controller('displayCtrl', displayCtrl)
  .config(displayRoutes)
  .run(displayRun)
  .service('displayMenu', displayMenu)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/display/display.module.js